import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
export type TranscriptSpeakerAssignmentKind = 'beneficiary' | 'contact' | 'other' | 'role';

/**
 * `contactId`, `displayName` and `roleKey` are only meaningful for one `kind` each: `toJSON()` emits only the
 * keys the retained `kind` needs, never the two together, mirroring the server's `@ValidateIf`. For `role`, `displayName` is sent only when non-empty after trim.
 */
class AssignTranscriptSpeaker {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly speakerId: number,
		public readonly kind: TranscriptSpeakerAssignmentKind,
		public readonly contactId: number | null,
		public readonly displayName: string | null,
		public readonly roleKey: string | null = null,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		if (this.kind === 'contact') {
			return { kind: this.kind, contactId: this.contactId };
		}

		if (this.kind === 'role') {
			const trimmedName = this.displayName?.trim() ?? '';

			if (trimmedName.length > 0) {
				return { kind: this.kind, roleKey: this.roleKey, displayName: trimmedName };
			}

			return { kind: this.kind, roleKey: this.roleKey };
		}

		if (this.kind === 'other') {
			return { kind: this.kind, displayName: this.displayName };
		}

		return { kind: this.kind };
	}
}

export default AssignTranscriptSpeaker;
